import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@material-ui/core";
import { authGet, authPut, authPost, Navigation } from "../../lib";
import { useDispatch } from "react-redux";
import { UIActions } from "../../state";

export function EditUserPage(props) {
  const userId = props.pageRoute.match.params.id;
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "" });
  const [saving, setSaving] = useState(false);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    (async () => {
      const response = await authGet(`/users/profile/${userId}`);
      if (response.data) {
        setUser(response.data);
        setForm({
          first_name: response.data.first_name || "",
          last_name: response.data.last_name || "",
          email: response.data.email || "",
        });
      }
    })();
  }, [userId]);

  const handleSave = async () => {
    setSaving(true);
    const response = await authPut(`/users/profile/${userId}`, form);
    setSaving(false);
    if (response.error) {
      dispatch(UIActions.showError("Failed to update user."));
    } else {
      dispatch(UIActions.showUpdated("User updated successfully."));
    }
  };

  const handleResendInvite = async () => {
    setSending(true);
    const response = await authPost(`/auth/password/forgot`, { email: form.email });
    setSending(false);
    if (response.error) {
      dispatch(UIActions.showError("Failed to send invite email."));
    } else {
      dispatch(UIActions.showUpdated(`Invite email sent to ${form.email}.`));
    }
  };

  if (!user) {
    return (
      <Box display="flex" justifyContent="center" mt={6}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box maxWidth={500} margin="0 auto" mt={4}>
      <Box mb={2}>
        <Button onClick={() => Navigation.go("/manage-users")}>← Back to Users</Button>
      </Box>
      <Typography variant="h6" gutterBottom>
        Edit User
      </Typography>
      <Box display="flex" flexDirection="column" style={{ gap: 16 }}>
        <TextField
          label="First Name"
          variant="outlined"
          value={form.first_name}
          onChange={(e) => setForm((p) => ({ ...p, first_name: e.target.value }))}
        />
        <TextField
          label="Last Name"
          variant="outlined"
          value={form.last_name}
          onChange={(e) => setForm((p) => ({ ...p, last_name: e.target.value }))}
        />
        <TextField
          label="Email"
          variant="outlined"
          value={form.email}
          onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))}
        />
        <Box display="flex" style={{ gap: 12 }} mt={1}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            disabled={saving || !form.first_name || !form.last_name || !form.email}
          >
            {saving ? <CircularProgress size={20} /> : "Save"}
          </Button>
          <Button
            variant="outlined"
            onClick={handleResendInvite}
            disabled={sending || !form.email}
          >
            {sending ? <CircularProgress size={20} /> : "Resend Invite Email"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
